import React from "react";
import { motion } from "framer-motion";

export default function Marquee({ text, className = "" }) {
  const items = Array(4).fill(text);
  return (
    <div className={`relative overflow-hidden select-none ${className}`} data-testid="editorial-marquee">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 32, ease: "linear", repeat: Infinity }}
      >
        {[...items, ...items].map((it, i) => (
          <span
            key={i}
            className="font-montserrat font-black text-[13vw] md:text-[9vw] leading-none tracking-tight px-6 text-transparent"
            style={{ WebkitTextStroke: "1.5px rgba(255,255,255,0.5)" }}
          >
            {it}
          </span>
        ))}
      </motion.div>
    </div>
  );
}
